import { Link } from "react-router-dom";
import type { CatalogItem } from "@/types/catalog";

interface MovieCardProps {
  item: CatalogItem;
}

export default function MovieCard({ item }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title}海报`}
          title={`${item.title} - ${item.categoryLabel} - ${item.genres.join(" ")}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium backdrop-blur-sm">
          {item.categoryLabel}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-0.5 px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-xs font-semibold">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-foreground-950/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-2">
          <span className="text-background-50 text-xs">{item.update}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {item.year} · {item.region} · {item.genres.slice(0, 2).join("/")}
        </p>
      </div>
    </Link>
  );
}